import React, { useState } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import FeaturesSection from './FeaturesSection';
import AssetsSection from './AssetsSection';
import EducationSection from './EducationSection';
import Footer from './Footer';
import SupportButton from '../SupportButton';

const LandingPage = ({ 
  user, 
  language, 
  onLogin, 
  onRegister, 
  onLogout, 
  onSwitchLanguage 
}) => {
  const [activeSection, setActiveSection] = useState('home');

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <Header
        user={user}
        language={language}
        activeSection={activeSection}
        onLogin={onLogin}
        onRegister={onRegister}
        onLogout={onLogout}
        onSwitchLanguage={onSwitchLanguage}
        onNavigate={scrollToSection}
      />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <section id="home">
          <HeroSection
            user={user}
            language={language}
            onRegister={onRegister}
            onLogin={onLogin}
          />
        </section>

        {/* About Section */}
        <section id="about">
          <AboutSection language={language} onRegister={onRegister} />
        </section>

        {/* Features Section */}
        <section id="features">
          <FeaturesSection language={language} onRegister={onRegister} />
        </section>

        {/* Assets Section */}
        <section id="assets">
          <AssetsSection language={language} onRegister={onRegister} />
        </section>

        {/* Education Section */}
        <section id="education">
          <EducationSection language={language} onRegister={onRegister} />
        </section>
      </main>

      {/* Footer */}
      <Footer language={language} />
      
      {/* Support Button */}
      <SupportButton />
    </div>
  );
};

export default LandingPage;